export function makeDisplayName(target, source, prefix) {
    target.displayName = "".concat(prefix, "(").concat(source.displayName || source.name || "unknown", ")");
    return target;
}
